import { gql } from '@apollo/client';
import { GetServerSideProps, NextPage } from 'next';
import { FOOTER_QUERY } from '../../components/footer';
import { Footer } from '../../components/footer';
import { HEADER_QUERY, Header } from '../../components/header';
import { ContentStackClient } from '../../lib/contentstack';
import {
  AllVertical,
  AllVerticalAlt,
  Vertical,
  VerticalAlt,
} from '../../types/contentstack';
import { IPageProps } from '../../types/page';
import {
  VERTICAL_PAGE_QUERY,
  VerticalPage,
} from '../../components/verticals/page';
import {
  VERTICAL_ALT_PAGE_QUERY,
  VerticalAltPage,
} from '../../components/verticals/page-alt';

export const Page: NextPage<IPageProps<Vertical | VerticalAlt>> = ({
  header,
  page,
  footer,
}) => {
  return (
    <>
      <Header
        pageTitle={page?.title}
        pageDescription={page?.description}
        {...header}
      />

      {page?.__typename === 'Vertical' && <VerticalPage page={page} />}

      {page?.__typename === 'VerticalAlt' && <VerticalAltPage page={page} />}

      <Footer sections={footer?.sections} {...page?.footer} marginTop={false} />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
  try {
    const id = params?.id as string[];
    const url = '/industries/' + id?.join('/');

    const { data } = await ContentStackClient().query<
      IPageProps<any> & {
        all_vertical: AllVertical;
        all_vertical_alt: AllVerticalAlt;
      }
    >({
      query: PAGES_QUERY,
      variables: { url },
    });

    const pageData =
      data?.all_vertical?.items?.[0] || data?.all_vertical_alt?.items?.[0];

    if (!pageData) {
      return {
        notFound: true,
        props: {},
      };
    }

    return {
      props: { ...data, page: pageData },
    };
  } catch (e: any) {
    return { props: {} };
  }
};

const PAGES_QUERY = gql`
  query verticalsQuery($url: String!) {
    ${HEADER_QUERY}
    ${FOOTER_QUERY}

    ${VERTICAL_PAGE_QUERY}
    ${VERTICAL_ALT_PAGE_QUERY}
  }
`;

export default Page;
